/*
 * Copyright (c) 2025.  Chad and contributors.
 * All rights reserved.
 */

import {useStore} from 'vuex';
import {computed} from 'vue';

export function useSquare() {
    const store = useStore();

    const squareLoading = computed(() => store.getters['square/loading']);

    const setSquareLoading = (payload) => {
        return store.commit('square/SET_SQUARE_LOADING', payload);
    }

    const saveSquareCode = (payload) => {
        return store.dispatch('square/saveSquareCode', payload);
    }

    const getSquareOauthUrl = async () => {
        return await store.dispatch('square/getSquareOauthUrl');
    }
    const getSquareProvider = async () => {
        return await store.dispatch('square/getSquareProvider');
    }
    return {
        squareLoading,
        saveSquareCode,
        getSquareOauthUrl,
        getSquareProvider,
        setSquareLoading,
    }
}